define('modules/lp_integration/models/integration_email',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");
  module.exports = Backbone.Model.extend({
    defaults: {
      active: true,
      recipients: [],
      subject: ""
    },
    i18n: {
      subjectError: $.i18n.t("integration.emailSubjectError"),
      recipientsError: $.i18n.t("integration.emailRecipientsError")
    },
    urlRoot: function(){
      return [config.apiHost, "pages", this.pageId, "integration"].join("/");
    },
    initialize: function(attrs,options){
      this.pageId = options.pageId;
    },
    saveRecipients: function(recipientList){
      recipientList = recipientList
        .replace(/,/g, ";")
        .split(";")
        .map(function(recipient){ return recipient && recipient.trim(); })
        .filter(function(recipient){ return recipient && recipient; });
      this.set("recipients", recipientList);
    },
    toJSON: function(){
      return _.omit(module.exports.__super__.toJSON.apply(this), "id");
    },

    validate: function(attrs, options){
      var errors = [];

      if(attrs.recipients.length === 0){
        //at lest one recipient is needed
        errors.push({
          attribute: "recipients",
          message: this.i18n.recipientsError
        });
      }

      if(!attrs.subject || !attrs.subject.trim()){
        //subject is mandatory
        errors.push({
          attribute: "subject",
          message: this.i18n.subjectError
        });
      }

      if(errors.length > 0){
        this.set("active",false);
        if (errors.length === 1) return errors;
      }
    },

    isEmpty: function() {
      return !this.get("recipients").length && !this.get("subject");
    },


  });
});

